import { styled } from '@mui/material';

export const StyledThumbnail = styled('img')`
  width: 180px;
  height: 320px;
`;
